import React from 'react';
import { Title, TitleProps } from '../title';
import { Tooltip } from '../tooltip';
import { Icons } from '@unifocus/react-icons';
import classnames from 'classnames';

/**
 * {@docCategory Heading}
 */
export interface HeadingProps extends TitleProps {
   /**
    * The help text of the heading.  Setting this property will cause an info icon to be shown
    * that will have a tooltip containing this text.
    */
   helpText?: string;

   /**
    * The info icon click handler.  Setting this property will cause an info icon to be shown.
    */
   onHelpClick?: () => void;

   /**
    * Theme
    */
   theme?: 'light' | 'dark';
}

export const Heading = (props: HeadingProps) => {

   const { helpText, onHelpClick, className, ...titleProps } = props;
   const classNames = classnames('uf-heading', {'uf-heading-dark': props.theme === 'dark'}, {'uf-heading-with-info-icon': helpText || onHelpClick}, props.className);

   if (helpText || onHelpClick) {
      return (<div className={classNames}>
         <Title {...titleProps}/>
         {helpText ?
          <Tooltip title={helpText}>
             <Icons.Information size={'sm'} className={'uf-heading-info-icon'}
                                onClick={onHelpClick}/>
          </Tooltip>
                   :
          <Icons.Information size={'sm'} className={'uf-heading-info-icon'} onClick={onHelpClick}/>
         }
      </div>);
   }
   return (<Title {...titleProps} className={classNames}/>);
};
